var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMundschutz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.616,
    height: 54.616,
    viewBox: "0 0 54.616 54.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_83",
    x: 0,
    y: 0,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mundschutz",
    transform: "translate(4.83 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -4.83, -6)",
    filter: "url(#Pfad_83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_83-2",
    "data-name": "Pfad 83",
    d: "M82.616,18.308A18.308,18.308,0,1,0,64.308,36.616,18.308,18.308,0,0,0,82.616,18.308",
    transform: "translate(-37 6)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_6",
    "data-name": "Vereinigungsmenge 6",
    d: "M.044,15.955s.236-1.175.443-2.589a24.321,24.321,0,0,0,10.105,3.858A24.317,24.317,0,0,1,.487,13.365c.125-.876.243-1.841.28-2.668.008-.188.015-.37.015-.544C.782,9.66.737,9.007.671,8.3.582,7.273.443,6.135.317,5.164h.17c.125-.312,3.82-.414,3.82-.414a25.483,25.483,0,0,0,3.112-.4C9.062,3.945,10.8,2.915,13.251,2.9c2.456.014,4.2,1.044,5.84,1.45,1.711.421,5.457.377,7.05,1.211-.111.878-.229,1.85-.31,2.734-.059.711-.1,1.364-.1,1.857,0,.174.007.356.015.544.037.827.155,1.792.28,2.668a24.314,24.314,0,0,1-10.109,3.858,24.318,24.318,0,0,0,10.109-3.858c.207,1.414.443,2.589.443,2.589a23.778,23.778,0,0,1-13.214,4.351A23.77,23.77,0,0,1,.044,15.955Zm19.047-11.6c-1.644-.407-3.385-1.436-5.84-1.45-2.456.014-4.188,1.044-5.833,1.45a25.483,25.483,0,0,1-3.112.4s-3.695.1-3.82.414H.317C.148,3.88,0,2.9,0,2.9c1.29-1.088,5.56-.994,7.418-1.45C9.062,1.044,10.8.014,13.251,0c2.456.014,4.2,1.044,5.84,1.45,1.858.457,6.128.363,7.418,1.45,0,0-.177,1.19-.369,2.661C24.548,4.728,20.8,4.772,19.091,4.351Z",
    transform: "translate(9.326 9.638)",
    fill: "#73c9e2",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_87",
    "data-name": "Pfad 87",
    d: "M116.569,251.547a24.3,24.3,0,0,1-13.019-4.118.431.431,0,0,1-.11-.606.447.447,0,0,1,.616-.108,21.751,21.751,0,0,0,25.031,0,.447.447,0,0,1,.616.108.431.431,0,0,1-.11.606,24.308,24.308,0,0,1-13.024,4.118",
    transform: "translate(-93.99 -224.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_88",
    "data-name": "Pfad 88",
    d: "M166.71,134.732a.433.433,0,0,1-.2-.051,13.919,13.919,0,0,0-4.221-.811,20.607,20.607,0,0,1-2.613-.362,16.451,16.451,0,0,1-1.625-.534,9.351,9.351,0,0,0-8.017,0,16.35,16.35,0,0,1-1.626.535,20.686,20.686,0,0,1-2.721.371l-.4.039a.435.435,0,0,1-.085-.866l.4-.039a20.293,20.293,0,0,0,2.592-.348,15.752,15.752,0,0,0,1.538-.508,10.186,10.186,0,0,1,8.617,0,15.793,15.793,0,0,0,1.538.507,20.194,20.194,0,0,0,2.488.34,14.008,14.008,0,0,1,4.544.909.435.435,0,0,1-.2.819",
    transform: "translate(-131.417 -119.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_89",
    "data-name": "Pfad 89",
    d: "M317.283,177.037a.433.433,0,0,1-.174-.037,17.028,17.028,0,0,0-5.976-1.414.435.435,0,0,1,.045-.869,17.9,17.9,0,0,1,6.28,1.486.435.435,0,0,1-.175.834",
    transform: "translate(-282.225 -158.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_90",
    "data-name": "Pfad 90",
    d: "M105.795,177.036a.435.435,0,0,1-.174-.834,17.974,17.974,0,0,1,6.287-1.486.435.435,0,1,1,.045.869A17.108,17.108,0,0,0,105.969,177a.433.433,0,0,1-.174.036",
    transform: "translate(-95.697 -158.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_91",
    "data-name": "Pfad 91",
    d: "M316.116,219.977a.435.435,0,0,1-.022-.87,10.285,10.285,0,0,0,5.365-1.83.435.435,0,1,1,.5.714,11.156,11.156,0,0,1-5.818,1.985h-.022",
    transform: "translate(-286.736 -197.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_92",
    "data-name": "Pfad 92",
    d: "M112.426,219.976H112.4a11.156,11.156,0,0,1-5.818-1.985.435.435,0,0,1,.5-.714,10.286,10.286,0,0,0,5.365,1.83.435.435,0,0,1-.022.87",
    transform: "translate(-96.643 -197.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_93",
    "data-name": "Pfad 93",
    d: "M40.827,99.45a7.633,7.633,0,0,0-2.66.741,8.851,8.851,0,0,1-2.252.7c-1.032-.7-3-.9-4.91-1.087a20.46,20.46,0,0,1-2.494-.336,16.032,16.032,0,0,1-1.542-.5,12.5,12.5,0,0,0-4.4-.963,12.447,12.447,0,0,0-4.381.962,15.924,15.924,0,0,1-1.541.5,20.454,20.454,0,0,1-2.494.336c-1.915.189-3.891.385-4.921,1.095a8.089,8.089,0,0,1-2.368-.707,7.614,7.614,0,0,0-2.657-.741c-2.558,0-4.211,1.921-4.211,4.9,0,3.459,1.88,4.8,4.26,6.488a24.642,24.642,0,0,1,4.662,4.02.548.548,0,0,0,.349.184,23.915,23.915,0,0,0,13.308,4.356,23.847,23.847,0,0,0,13.461-4.467l.01-.009c.013-.011.025-.022.038-.034l.017-.018.012-.012a24.645,24.645,0,0,1,4.662-4.02c2.38-1.693,4.26-3.03,4.26-6.488,0-2.974-1.653-4.9-4.211-4.9M4.9,109.95c-2.29-1.628-3.8-2.7-3.8-5.6,0-.893.224-3.807,3.112-3.807a7.1,7.1,0,0,1,2.242.66,9.94,9.94,0,0,0,2.485.766c.058.406.15,1.058.249,1.811.116.9.26,2.073.349,3.114.071.771.107,1.379.107,1.807,0,.165-.007.347-.014.52-.03.674-.119,1.53-.273,2.615-.087.6-.179,1.157-.257,1.6a27.346,27.346,0,0,0-4.2-3.48m17.678,8.355a23.189,23.189,0,0,1-12.513-4.043c.085-.455.24-1.315.379-2.278.159-1.122.252-2.011.283-2.723.007-.186.015-.379.015-.565,0-.468-.037-1.092-.112-1.9-.091-1.057-.237-2.241-.354-3.156-.109-.833-.21-1.543-.267-1.939a13.978,13.978,0,0,1,4.257-.813,20.97,20.97,0,0,0,2.652-.364,16.714,16.714,0,0,0,1.653-.538,11.371,11.371,0,0,1,4-.9,11.42,11.42,0,0,1,4.017.9,16.819,16.819,0,0,0,1.653.538,20.975,20.975,0,0,0,2.651.363,13.975,13.975,0,0,1,4.257.814c-.066.457-.19,1.337-.319,2.34-.107.856-.228,1.852-.31,2.756-.049.59-.1,1.339-.1,1.9,0,.187.008.379.015.568.031.709.124,1.6.283,2.722.14.962.294,1.822.379,2.276a23.141,23.141,0,0,1-12.518,4.043m17.558-8.355a27.734,27.734,0,0,0-4.094,3.371c-.073-.423-.158-.938-.238-1.488-.154-1.087-.244-1.943-.273-2.614-.007-.175-.014-.357-.014-.522,0-.523.054-1.244.1-1.808.08-.884.2-1.869.305-2.713.12-.93.236-1.753.3-2.227a10.661,10.661,0,0,0,2.355-.749,7.124,7.124,0,0,1,2.245-.661c2.888,0,3.112,2.914,3.112,3.807,0,2.9-1.513,3.976-3.8,5.6",
    transform: "translate(0 -88.903)",
    fill: "#3f3f3f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMundschutz);
export default __webpack_public_path__ + "static/media/mundschutz.d4759ab111ea35d3ea933a417e74c384.svg";
export { ForwardRef as ReactComponent };